'use es6';

export const DESCRIPTION = 'DESCRIPTION';
export const EDITOR = 'EDITOR';